import Request from '../../../../src/core/gd/data/request'
import DatetimeUtils from "../utils/datetime-utils"
import {SystemStatusFilter} from "../../gd-components/finder/task/@types";

export default class ApiSearch {

    static tasks(query: string, status: SystemStatusFilter, startDate: Moment | null, endDate: Moment | null, companyId: ID) {
        const params: any = {
            query       : query,
            systemStatus: status,
        }
        if (startDate)  params.startDate = gd.utils.momentToDate(startDate)
        if (endDate)    params.endDate = gd.utils.momentToDate(endDate)
        if (companyId)  params.companyId = companyId

        return new Request(this,'GET','search/task', params)
    }

    tasks(query: string, status: SystemStatusFilter, startDate: Moment | null, endDate: Moment | null, companyId: ID) {
        return ApiSearch.tasks(query, status, startDate, endDate, companyId)
    }

    static events(query: string, status: SystemStatusFilter, startDate?: Moment, endDate?: Moment) {
        const params: any = {
            query       : query,
            systemStatus: status,
            companyId   : gd.companyId,
        }
        if (startDate)  params.startDate = gd.utils.momentToDate(startDate)
        if (endDate)    params.endDate = gd.utils.momentToDate(endDate)

        return new Request(this,'GET','search/events', params)
    }

    projects(query: any, startDate: Moment, endDate: Moment) {
        const params: any = {
            query: query
        }
        if (startDate)  params.startDate = gd.utils.momentToDate(startDate)
        if (endDate)    params.endDate = gd.utils.momentToDate(endDate)

        return new Request(this,'GET','search/project',params)
    }

    notes(query: any, startDate?: Moment, endDate?: Moment) {
        const params: any = {
            query: query
        }
        if (startDate)  params.startDate = gd.utils.momentToDate(startDate)
        if (endDate)    params.endDate = gd.utils.momentToDate(endDate)

        return new Request(this,'GET','search/note',params)
    }

    /*tasksById(taskId) {
        return new Request(this,'GET','search/task-id',{
            taskId: taskId
        });
    }*/

    /** V4.14 **/

    quick(query: string, projectIds?: ID[]) {

        const params: any = {
            query: query
        }

        if(projectIds && !_.isEmpty(projectIds)){
            params.projectIds = projectIds
        }

        return new Request(this,'POST','search/v414/quick', params)
    }

    tasksV414(query: string, systemStatus: 'open' | 'closed' | 'all', createdStartDate: Moment, createdEndDate: Moment, involvedUserId: ID, projectId: ID) {
        const params: any = {query}
        params.systemStatus = systemStatus ? systemStatus : 'all'

        if (createdStartDate)   params.createdStartDate = DatetimeUtils.momentToDate(createdStartDate)
        if (createdEndDate)     params.createdEndDate = DatetimeUtils.momentToDate(createdEndDate)
        if (involvedUserId)     params.involvedUserId = involvedUserId
        if (projectId)          params.projectId = projectId

        return new Request(this,'POST','search/v414/task',params)
    }

    projectsV414(query: string, createdStartDate: Moment, createdEndDate: Moment) {
        const params: any = {
            query: query
        }
        if (createdStartDate)  params.createdStartDate = gd.utils.momentToDate(createdStartDate)
        if (createdEndDate)    params.endDcreatedEndDateate = gd.utils.momentToDate(createdEndDate)

        return new Request(this,'POST','search/v414/project',params)
    }

    notesV414(query: string, createdStartDate: Moment, createdEndDate: Moment, projectId: ID) {
        const params: any = {query}

        if (createdStartDate)   params.createdStartDate = DatetimeUtils.momentToDate(createdStartDate)
        if (createdEndDate)     params.createdEndDate = DatetimeUtils.momentToDate(createdEndDate)
        if (projectId)          params.projectId = projectId

        return new Request(this,'POST','search/v414/document',params)
    }

    eventsV414(query: string, eventStartDate: Moment, eventEndDate: Moment, userId: ID, projectId: ID) {
        const params: any = {query}

        if (eventStartDate)     params.eventStartDate = DatetimeUtils.momentToDate(eventStartDate)
        if (eventEndDate)       params.eventEndDate = DatetimeUtils.momentToDate(eventEndDate)
        if (userId)             params.userId = userId
        if (projectId)          params.projectId = projectId

        return new Request(this,'POST','search/v414/event',params)
    }

    chatsV414(query: string, createdStartDate: Moment, createdEndDate: Moment, involvedUserId: ID, projectId: ID) {
        const params: any = {query}

        if (createdStartDate)   params.createdStartDate = DatetimeUtils.momentToDate(createdStartDate)
        if (createdEndDate)     params.createdEndDate = DatetimeUtils.momentToDate(createdEndDate)
        if (involvedUserId)     params.userId = involvedUserId
        if (projectId)          params.projectId = projectId

        return new Request(this,'POST','search/v414/chat',params)
    }
}
